import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=3bce8601&"
import script from "./Platform.vue?vue&type=script&lang=js&"
export * from "./Platform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports